// eslint-disable-next-line import/no-cycle
import { fetchCompetitionByStatus, fetchWidgetsData } from "apis/compete";
import { put, takeLatest } from "redux-saga/effects";
import { enqueueSnackbar } from "notistack";
import { competeAction } from "../slice/compete";

export function* getWidgetsData({ payload }) {
  try {
    const response = yield fetchWidgetsData(payload);
    if (response?.data?.success) {
      yield put(competeAction.getWidgetsDataSuccess(response?.data?.data));
    } else if (response?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: response?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(competeAction.getWidgetsDataFailure());
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(competeAction.getWidgetsDataFailure());
  }
}

export function* getOpenCompetitions({ payload }) {
  try {
    const response = yield fetchCompetitionByStatus(payload);
    if (response?.data?.success) {
      yield put(competeAction.getOpenCompetitionsSuccess(response?.data?.data));
    } else if (response?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: response?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(competeAction.getOpenCompetitionsFailure());
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(competeAction.getOpenCompetitionsFailure());
  }
}
export function* getUpcomingCompetitions({ payload }) {
  try {
    const response = yield fetchCompetitionByStatus(payload);
    if (response?.data?.success) {
      yield put(competeAction.getUpcomingCompetitionsSuccess(response?.data?.data));
    } else if (response?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: response?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(competeAction.getUpcomingCompetitionsFailure());
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(competeAction.getUpcomingCompetitionsFailure());
  }
}
export function* getClosedCompetitions({ payload }) {
  try {
    const response = yield fetchCompetitionByStatus(payload);
    if (response?.data?.success) {
      yield put(competeAction.getClosedCompetitionsSuccess(response?.data?.data));
    } else if (response?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: response?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(competeAction.getClosedCompetitionsFailure());
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(competeAction.getClosedCompetitionsFailure());
  }
}

export function* watchCompetedAsync() {
  yield takeLatest(competeAction.getWidgetsDataRequest, getWidgetsData);
  yield takeLatest(competeAction.getOpenCompetitionsRequest, getOpenCompetitions);
  yield takeLatest(competeAction.getUpcomingCompetitionsRequest, getUpcomingCompetitions);
  yield takeLatest(competeAction.getClosedCompetitionsRequest, getClosedCompetitions);
}
